import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "rhodes" | "ghost" | "subtle" | "danger";
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  loadingLabel?: string;
  icon?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = "subtle", size = "md", loading = false, loadingLabel, icon, children, className, disabled, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      className={`bd-btn bd-btn--${variant}${size !== "md" ? ` bd-btn--${size}` : ""}${className ? ` ${className}` : ""}`}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? <span className="bd-btn__spinner" aria-hidden /> : icon}
      {loading && loadingLabel ? loadingLabel : children}
    </button>
  );
});
